<!--
* @Author: zhangping
* @Date: 2025-06-26 14:44:54
* @Description: 店检记录
-->

<template>
    <div class="ir pl-20">
        <div v-for="(item, index) in inspectionRecordList" :key="index" class="mb-30">
            <h3>{{ item.yearMonthStr }}</h3>
            <div v-if="item.inspectionStatus === 1">未上传</div>
            <template v-else>
                <p class="mt-10">提交时间：{{ item.applyTime }}</p>
                <Tag color="warning" v-if="item.auditDetailStatus === 1">待业务主管审核</Tag>
                <Tag color="primary" v-if="item.auditDetailStatus === 2">待渠道员审核</Tag>

                <Tag color="green" v-if="item.appealStatus === 3">申诉审核合格</Tag>
                <Alert
                    type="success"
                    v-if="item[item.appealStatus === 3 ? 'preInspectionStatus' : 'inspectionStatus'] === 4"
                >
                    <div class="alert-wrapper">
                        <Tag color="success" class="mr-10 wsnw">审核合格</Tag>
                        <p>审核门店类型：{{ item.auditStoreTypeStr }}</p>
                    </div>
                </Alert>
                <Alert
                    type="error"
                    style="width: 600px"
                    class="mt-5"
                    v-if="item[item.appealStatus === 3 ? 'preInspectionStatus' : 'inspectionStatus'] === 5"
                >
                    <div class="por">
                        <Tag color="error" class="poa" style="top: 50%; left: 0; transform: translateY(-60%)">
                            已驳回
                        </Tag>
                        <div class="pl-60">
                            <div class="df">
                                <div style="flex: 0 0 70px">驳回原因：</div>
                                <div>
                                    {{ item.rejectReason || '-' }}
                                </div>
                            </div>
                            <p class="mt-5">审核人：{{ item.finalAuditSalesmanName }}</p>
                        </div>
                    </div>
                </Alert>
                <Alert
                    type="error"
                    v-if="item[item.appealStatus === 3 ? 'preInspectionStatus' : 'inspectionStatus'] === 6"
                >
                    <div class="alert-wrapper">
                        <Tag color="error" class="mr-10 wsnw">审核不合格</Tag>
                        <p>审核人：{{ item.finalAuditSalesmanName }}</p>
                    </div>
                </Alert>

                <div v-viewer class="mt-10">
                    <span v-for="src in item.currentImgUrlList" :key="src" class="ir-img mr-10 dib">
                        <img :src="src" />
                        <el-icon><CirclePlus /></el-icon>
                    </span>
                </div>
            </template>
        </div>
        <div class="mt-20 tar">
            <Page
                :total="pageConfig.total"
                show-total
                show-sizer
                show-elevator
                :page-size-opts="[10, 20, 30, 40]"
                :page-size="pageConfig.size"
                :current.sync="pageConfig.current"
                @on-change="onPageChange"
                @on-page-size-change="onPageSizeChange"
            />
        </div>
    </div>
</template>

<script>
import { apiStoreInspectionRecord } from '@/api/store';
export default {
    props: {
        storeId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            inspectionRecordList: [],
            pageConfig: {
                current: 1,
                size: 10,
                total: 0,
            },
        };
    },
    created() {
        this.getData();
    },
    methods: {
        // 获取店检记录
        async getData() {
            try {
                const params = { storeId: this.storeId, current: this.pageConfig.current, size: this.pageConfig.size };
                const res = await apiStoreInspectionRecord(params);
                this.inspectionRecordList = res.list;
                this.pageConfig.total = Number(res.total);
            } catch (error) {}
        },
        onPageChange(val) {
            this.pageConfig.current = val;
            this.getData();
        },
        onPageSizeChange(val) {
            this.pageConfig.current = 1;
            this.pageConfig.size = val;
            this.getData();
        },
    },
};
</script>

<style lang="less" scoped>
.ir {
    .ir-img {
        width: 200px;
        height: 150px;
        border-radius: 10px;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
        }
    }
}
</style>
